import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q19 = ({ history }) => {
  const { t } = useTranslation();
  const Q19Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
      {
        id: 2,
        name: t('not_sure'),
        value: 'not_sure',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question19')}
      options={Q19Options}
      nextUrl="q20"
      screenName="q19"
    />
  );
};

export default Q19;
